import Image from "next/image";
import { Stack, Box, Text } from "@chakra-ui/react";
import Logo from "public/footer/footer-logo.png";
import { FOOTER_CONSTANTS } from "../footer.constants";
import FooterContactInfo from "./footerContactInfo";
import { TEXT_VARIANTS } from "@/theme/components/text";

const FooterBranding = () => {
  return (
    <Box position={"relative"} py={12} top={{ base: 0, md: -16 }} width="full">
      <Stack alignItems={"start"} spacing={6} color="white">
        <Image alt="logo" src={Logo} width={200} />
        <Text fontWeight={400} variant={TEXT_VARIANTS.TAGLINE}>
          {FOOTER_CONSTANTS.BRAND_TEXT}
        </Text>
        <FooterContactInfo />
      </Stack>
    </Box>
  );
};

export default FooterBranding;
